export default "__VITE_ASSET__B$GmsmuI__ 584w";